function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
  const R = 6371; // Radius of the earth in km
  const dLat = deg2rad(lat2-lat1)  // deg2rad below
  const dLon = deg2rad(lon2-lon1)
  const a = 
    Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * 
    Math.sin(dLon/2) * Math.sin(dLon/2) 
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a))
  const d = R * c // Distance in km
  return d
};

function deg2rad(deg) {
  return deg * (Math.PI/180)
};

const transmitters = [
  {
    id: 'WUFT',
    city: 'Gainesville',
    lat: 29.50,
    lon: -82.50,
    distance: '',
    logo: 'logos/WUFT.png',
    stream: 'http://ais-sa1.streamon.fm/7647_64k.mp3'
  },
  {
    id: 'WGCU',
    city: 'Ft. Myers',
    lat: 26.64,
    lon: -81.87,
    distance: '',
    logo: 'logos/WGCU.png',
    stream: 'https://playerservices.streamtheworld.com/api/livestream-redirect/WGCUFM.mp3'
  },
  {
    id: 'WQCS',
    city: 'Fort Pierce',
    lat: 27.45,
    lon: -80.33,
    distance: '',
    logo: 'logos/WQCS.png',
    stream: 'http://96.69.32.253:8006/hd1?type=http'
  },
  {
    id: 'WJCT',
    city: 'Jacksonville',
    lat: 30.33,
    lon: -81.66,
    distance: '',
    logo: 'logos/WJCT.png',
    stream: 'https://playerservices.streamtheworld.com/api/livestream-redirect/WJCTFM.mp3'
  },
  {
    id: 'WFIT',
    city: 'Melbourne',
    lat: 28.08,
    lon: -80.61,
    distance: '',
    logo: 'logos/WFIT.png',
    stream: 'https://streaming.wfit.org/wfit-fm'
  },
  {
    id: 'WLRN',
    city: 'Miami',
    lat: 25.76,
    lon: -80.19,
    distance: '',
    logo: 'logos/WLRN.png',
    stream: 'https://stream.wlrn.mobi/WLRNFMAAC32'
  },
  {
    id: 'WMFE',
    city: 'Orlando',
    lat: 28.54,
    lon: -81.38,
    distance: '',
    logo: 'logos/WMFE.png',
    stream: 'https://wmfe-iad.streamguys1.com/wmfe'
  },
  {
    id: 'WKGC',
    city: 'Panama City',
    lat: 30.16,
    lon: -85.66,
    distance: '',
    logo: 'logos/WKGC.png',
    stream: 'https://ice24.securenetsystems.net/WKGCFM?&playSessionID=CA8A1E64-F8CB-D1FF-F45D4FE817C0950A'
  },
  {
    id: 'WUWF',
    city: 'Pensacola',
    lat: 30.42,
    lon: -87.22,
    distance: '',
    logo: 'logos/WUWF.png',
    stream: 'https://18153.live.streamtheworld.com/WUWFFM_SC'
  },
  {
    id: 'WFSU',
    city: 'Tallahassee',
    lat: 30.44,
    lon: -84.28,
    distance: '',
    logo: 'logos/WFSU.png',
    stream: 'https://mp3stream.wfsu.org:8443/889hi'
  },
  {
    id: 'WUSF',
    city: 'Tampa',
    lat: 27.95,
    lon: -82.46,
    distance: '',
    logo: 'logos/WUSF.png',
    stream: 'https://17613.live.streamtheworld.com/WUSFFM.mp3'
  },
  {
    id: 'WMNF',
    city: 'Tampa',
    lat: null,
    lon: null,
    distance: '',
    logo: 'logos/WMNF.png',
    stream: 'https://stream.wmnf.org:4443/wmnf_high_quality'
  }
]

function transmittersMetaData(userLat, userLon) {
  // Calculate distance from the user to each transmitter site and add the distance into each array of the transmitter object
  transmitters.map(transmitter => transmitter.distance = getDistanceFromLatLonInKm(userLat, userLon, transmitter.lat, transmitter.lon));
  
  // Find shortest distance and return the metadata to the caller
  const shortestDistance = transmitters.reduce((prev, current) => prev.distance < current.distance ? prev : current)

  return shortestDistance;
}

function getStationMetaData(stationId) {
  const affiliate = transmitters.find(transmitter => stationId === transmitter.id)
  return {
    city: affiliate.city,
    lat: affiliate.lat,
    lon: affiliate.lon
  }
}

export { transmitters, transmittersMetaData, getStationMetaData }